import { Step } from '@/context/wizard/components/step';
import { useWizard } from '@/context/wizard/index';
import type { WizardProps } from '@/context/wizard/types';

export const Wizard: React.FC<WizardProps> = ({ steps }) => {
  const { currentStepId } = useWizard();
  const currentStep = steps[currentStepId];

  if (!currentStep) {
    console.warn(`Step "${currentStepId}" not found in steps definition`);
    return null;
  }

  return <Step {...currentStep} />;
};
